<template>
  <section v-if="custUrl">
    <div class="kefu"><a :href="custUrl" target="_blank"><img src="../assets/imgs/kefu.png" alt=""></a></div>
  </section>
</template>
<script>
import { axiosServer } from '@/api/http';
import { getSign } from "@/api/utils";
export default {
  name: 'cust',
  props: {
    custgame: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      game_id: localStorage.getItem('game_id'),
      area: localStorage.getItem('area'),
      app_key: '1df869f2e620513484ddbd5521313a60',
      custUrl: 'https://www.facebook.com/SoulChronicle.Asia/',
    }
  },
  created() {
    this.getCustUrl();
  },
  methods: {
    getCustUrl() {
      let params = {
        game_id: this.custgame ? '' : this.game_id,
        area: this.custgame ? '' : this.area,
      }
      axiosServer({
        url: "custUrl",
        type: "post",
        params: {
          ...params,
          sign: getSign(this.app_key, params),
        },
      }).then((res) => {
        if (res.data.ret == 0) {
          this.custUrl = res.data.data.social_media_url
        }
      })
    }
  }
}
</script>
<style>
.kefu{position: fixed;right: 0rem;bottom: 2.4rem;}
.kefu img{width: .63rem;}
</style>